import { Box } from "@mui/material";
import { useEffect } from "react";
import AssetsTransItem from "./AssetsTransItem.tsx";
import classes from "./index.module.less";
import { toDateGroupTitle } from "@/utils/dateUtils.js";

interface Props {
  dateText: string;
  list: any[],
  onClick: (item: any) => void;
}

const DayAssetsTransItem = (props: Props) => {
  const {dateText, list, onClick} = props;

  return (<>
    <Box className={classes["flow-container"]}>
      <Box>
        {/*dayjs(dateText).format('dddd, MMMM d')*/}
        {/*<p className={classes["flow-date"]}>{dayjs(dateText).format('dddd, MMMM d')}</p>*/}
        <p className={classes["flow-date"]}>{toDateGroupTitle(dateText)}</p>
      </Box>
      {
        list.map((item, idx) => (
          <Box key={dateText + idx} onClick={() => {onClick && onClick(item)}}>
            <AssetsTransItem record={item} key={dateText}/>
          </Box>
        ))
      }
    </Box>
  </>)
}

export default DayAssetsTransItem